import React from 'react'
import {
    Checkbox as ChakraCheckbox,
    useStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {CheckIcon} from '../../components/icons'
import PropTypes from 'prop-types'

const CustomCheckIcon = (props) => {
    const {isChecked, ...rest} = props
    return isChecked ? <CheckIcon {...rest} /> : null
}

CustomCheckIcon.propTypes = {
    isChecked: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
}

const Checkbox = React.forwardRef((props, ref) => {
    const styles = useStyleConfig('Checkbox', {variant: props.variant})
    return (
        <ChakraCheckbox
            {...props}
            ref={ref}
            sx={{
                ...styles,
                ...(props?.isError && {
                    '.chakra-checkbox__control': {
                        borderColor: 'text.danger',
                    },
                }),
            }}
            icon={<CustomCheckIcon isChecked={props.isChecked} />}
        />
    )
})
Checkbox.displayName = 'Checkbox'

Checkbox.propTypes = {
    isChecked: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    isDisabled: PropTypes.bool,
    onChange: PropTypes.func,
    children: PropTypes.node,
    variant: PropTypes.string,
    isError: PropTypes.bool,
}

export default Checkbox
